import _slicedToArray from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { useCallback, useEffect, useState } from 'react';
import { apiGetTripartiteCooperationInfoBySlug } from '../../api/combineApi';
import { resolvePortalIntroCountryCode, resolvePortalIntroInfoFromBrokerEntity } from '../../ui/portal/intro/utils';
import { useJoveCountryInfo } from '../useJoveCountryInfo';
export var usePortalIntroInfo = function usePortalIntroInfo(slug, countryCode) {
  var _useJoveCountryInfo = useJoveCountryInfo(),
      requestUserCountryCode = _useJoveCountryInfo.requestUserCountryCode;

  var _useState = useState({}),
      introInfo = _useState[0],
      setIntroInfo = _useState[1];

  var _useState2 = useState(),
      resolvedCountry = _useState2[0],
      setResolvedCountry = _useState2[1];

  var _useState3 = useState(true),
      loading = _useState3[0],
      setLoading = _useState3[1];
  /**
   * request
   */


  var requestIntroInfo = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(targetSlug, targetCountryCode) {
      var _res$payload;

      var _yield$apiGetTriparti, _yield$apiGetTriparti2, res, resolvedCountryCode;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (targetSlug) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              setLoading(true);
              _context.next = 5;
              return apiGetTripartiteCooperationInfoBySlug({
                slug: targetSlug
              });

            case 5:
              _yield$apiGetTriparti = _context.sent;
              _yield$apiGetTriparti2 = _slicedToArray(_yield$apiGetTriparti, 1);
              res = _yield$apiGetTriparti2[0];
              _context.t0 = targetCountryCode;

              if (_context.t0) {
                _context.next = 13;
                break;
              }

              _context.next = 12;
              return requestUserCountryCode();

            case 12:
              _context.t0 = _context.sent;

            case 13:
              resolvedCountryCode = _context.t0;
              setLoading(false); // The effective country version also drives the language of the design-default copy on the page

              setResolvedCountry(resolvePortalIntroCountryCode(res === null || res === void 0 ? void 0 : (_res$payload = res.payload) === null || _res$payload === void 0 ? void 0 : _res$payload.sub_broker_portal_settings, resolvedCountryCode));
              setIntroInfo(resolvePortalIntroInfoFromBrokerEntity(res, resolvedCountryCode)); // eslint-disable-next-line react-hooks/exhaustive-deps

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  /**
   * effects
   */

  useEffect(function () {
    requestIntroInfo(slug, countryCode);
  }, [slug, countryCode, requestIntroInfo]);
  return {
    introInfo: introInfo,
    loading: loading,
    requestIntroInfo: requestIntroInfo,
    resolvedCountry: resolvedCountry
  };
};